import { safeOnError } from '@rehaje/shared'

import { Abort } from '../constants'
import { DISPOSED, Effect } from '../signal'

import type { DisposeFn } from '../signal'
import type { EffectOptions } from '../types'
import type { Callback, Disposer, DisposerLike } from '@rehaje/shared'

class Autorun extends Effect {
  _disposeFn?: DisposeFn

  override _callback(): void {
    const finish = this._start()
    try {
      if (!this._fn || this._flags & DISPOSED) return
      this._disposeFn = this._fn() ?? undefined
      this._version++
    } catch (error) {
      if (error !== Abort) {
        if (this._onError) this._onError(error, this._version === 0)
        else throw error
      }
    } finally {
      finish()
    }
  }

  override _dispose(): void {
    super._dispose()
    if (typeof this._disposeFn === 'function') this._disposeFn()
  }
}

export function autorun(
  tracker: Callback<DisposerLike>,
  options?: EffectOptions
): Disposer {
  const autorun = new Autorun(tracker)
  autorun._onError = safeOnError(options?.onError)
  try {
    autorun._callback()
  } catch (error) {
    autorun._dispose()
    throw error
  }
  return autorun._dispose.bind(autorun)
}
